import { InfoModalActionType } from '../../types/infoModalType'

export const closeInfoModal = () => {
    return {type: InfoModalActionType.INFO_MODAL_CLOSE}
}

export const openInfoModal = () => {
    return {type: InfoModalActionType.INFO_MODAL_OPEN}
}